<div class="preloader d-flex align-items-center justify-content-center" *ngIf="isLoading">
    <div class="cssload-container">
        <div class="cssload-loading"><i></i><i></i><i></i><i></i></div>
    </div>
</div>